/* Copyright (c) 2017 Backpack Health LLC */


// const colorBlue = '#007AFF';
// // const colorRedDark = '#E20D0D';
// const colorRedLight = '#FD3235';
// const colorGreen = '#2BC552';
// // const colorOrange = '#FDA732';
// // const colorPurple = '#8A2BE2';
// // const colorBlueDark = '#2C70BB';

// const grayscaleDarkest = '#111111';
// // const grayscaleDark = '#3C3C3C';
// // const grayscaleMedDark = '#555555';
// const grayscaleMiddle = '#9E9E9E';
// // const grayscaleMedLight = '#BFBFBF';
// // const grayscaleLight = '#E7E7E7';
// const grayscaleLightest = '#FFFFFF';

// // const colorBrandPrimary = '#E20D0D';
// // const colorBrandSecondary = '#FFFFFF';

// const disabledOverlayProfileColor = 'rgba(0, 0, 0, 0.15)';
// const enabledOverlayProfileColor = 'rgba(0, 0, 0, 0.5)';
// const darkOverlayColor = 'rgba(17, 17, 17, 0.3)';


export default {
  gsDarkest: 'rgb(17, 17, 17)',
  gsDark: 'rgb(65, 65, 65)',/* #414141 */
  gsMedDark: 'rgb(100, 100, 100)',/* #646464 */
  gsMiddle: 'rgb(160, 160, 160)',/* A0A0A0 */
  gsMedLight: 'rgb(183, 183, 183)',/* #B7B7B7 */
  gsLight: 'rgb(231, 231, 231)',/* #E7E7E7 */
  gsLightest: 'rgb(255, 255, 255)',/* #FFF */
  gsDark60: 'rgba(65, 65, 65, 0.60)',

  gsDarkDT: 'rgba(17, 17, 17, 0.80)',
  gsMedDarkDT: 'rgba(17, 17, 17, 0.65)',
  gsMiddleDT: 'rgba(17, 17, 17, 0.40)',
  gsMedLightDT: 'rgba(17, 17, 17, 0.30)',
  gsLightDT: 'rgba(17, 17, 17, 0.10)',

  gsDarkLT: 'rgba(255, 255, 255, 0.25)',
  gsMedDarkLT: 'rgba(255, 255, 255, 0.40)',
  gsMiddleLT: 'rgba(255, 255, 255, 0.65)',
  gsMedLightLT: 'rgba(255, 255, 255, 0.75)',
  gsLightLT: 'rgba(255, 255, 255, 0.90)',

  transparent: 'transparent',

  bcBackpackRedAccent: 'rgba(160, 0, 41, 1)',
  bcBackpackRedBase: 'rgba(216, 27, 81, 1)',


  // navDefault: grayscaleLightest,
  // navFooterDefault: colorBlue,
  // navDisabled: grayscaleMiddle,
  // iconBlue: colorBlue,
  // iconRed: colorRedLight,
  // iconGreen: colorGreen,
  // whiteText: grayscaleLightest,
  // darkText: grayscaleDarkest,
  // disabledOverlayProfileColor,
  // enabledOverlayProfileColor,
  // darkOverlayColor,
};
